import React, { useEffect, useState } from "react"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import DialogActions from "@material-ui/core/DialogActions"
import Button from "@material-ui/core/Button"
import Table from "@material-ui/core/Table"
import TableHead from "@material-ui/core/TableHead"
import TableBody from "@material-ui/core/TableBody"
import TableRow from "@material-ui/core/TableRow"
import TableCell from "@material-ui/core/TableCell"
import Chip from "@material-ui/core/Chip"
import CircularProgress from "@material-ui/core/CircularProgress"

import { buscarExtratoQuitacao } from "../../services/quitacaoAutomatica"

/**
 * Extrato completo da quitação automática via Pix, espelhando a tela
 * QuitacaoExtratoFornecedor do sistemaadm: totais, faturas em aberto e movimentos.
 */
export default function ExtratoDialog({ open, onClose, auth, idEstab }) {
    const [carregando, setCarregando] = useState(false)
    const [extrato, setExtrato] = useState(null)

    useEffect(() => {
        let ativo = true
        if (open && auth && idEstab) {
            setCarregando(true)
            buscarExtratoQuitacao(auth, idEstab).then(dados => {
                if (!ativo) return
                setExtrato(dados)
                setCarregando(false)
            })
        }
        return () => {
            ativo = false
        }
    }, [open, auth, idEstab])

    const totais = [
        { label: "Saldo em aberto", valor: extrato?.totalEmAberto, cor: "#b12a1d" },
        { label: "Total creditado", valor: extrato?.totalCreditado, cor: "#1cc88a" },
        { label: "Total estornado", valor: extrato?.totalEstornado, cor: "#e74a3b" },
    ]

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Extrato de Quitação Automática</DialogTitle>
            <DialogContent dividers>
                {carregando && (
                    <div style={{ textAlign: "center", padding: "2em" }}>
                        <CircularProgress />
                    </div>
                )}

                {!carregando && !extrato && (
                    <p>Não foi possível carregar o extrato. Tente novamente.</p>
                )}

                {!carregando && extrato && (
                    <>
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "1em",
                                marginBottom: "1.5em",
                            }}
                        >
                            {totais.map(t => (
                                <div
                                    key={t.label}
                                    style={{
                                        flex: "1 1 160px",
                                        border: "1px solid #eee",
                                        borderRadius: "6px",
                                        padding: "0.75em 1em",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "0.7rem",
                                            fontWeight: "bold",
                                            textTransform: "uppercase",
                                            color: "#858796",
                                        }}
                                    >
                                        {t.label}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: "1.1rem",
                                            fontWeight: "bold",
                                            color: t.cor,
                                        }}
                                    >
                                        {t.valor || "R$ 0,00"}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <h6 style={{ fontWeight: "bold" }}>Faturas em aberto</h6>
                        {extrato.faturasEmAberto && extrato.faturasEmAberto.length ? (
                            <Table size="small" style={{ marginBottom: "1.5em" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Referência</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell align="right">Valor</TableCell>
                                        <TableCell align="right">Pago</TableCell>
                                        <TableCell align="right">Saldo</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {extrato.faturasEmAberto.map(f => (
                                        <TableRow key={f.id}>
                                            <TableCell>
                                                {f.referencia}
                                                {f.alvo && (
                                                    <Chip
                                                        label="Quitando agora"
                                                        size="small"
                                                        color="primary"
                                                        style={{ marginLeft: "0.5em" }}
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell>{f.status}</TableCell>
                                            <TableCell align="right">{f.valor}</TableCell>
                                            <TableCell align="right">{f.valorPago}</TableCell>
                                            <TableCell align="right">{f.saldo}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        ) : (
                            <p style={{ color: "#858796" }}>Nenhuma fatura em aberto.</p>
                        )}

                        <h6 style={{ fontWeight: "bold" }}>Movimentos</h6>
                        {extrato.movimentos && extrato.movimentos.length ? (
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Data</TableCell>
                                        <TableCell>Origem</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell align="right">Valor</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {extrato.movimentos.map((m, i) => (
                                        <TableRow key={i}>
                                            <TableCell>{m.data}</TableCell>
                                            <TableCell>{m.origem}</TableCell>
                                            <TableCell>
                                                {m.status === "ESTORNADO" ? (
                                                    <span style={{ color: "#e74a3b" }}>
                                                        Estornado
                                                    </span>
                                                ) : (
                                                    <span style={{ color: "#1cc88a" }}>
                                                        Creditado
                                                    </span>
                                                )}
                                            </TableCell>
                                            <TableCell align="right">{m.valor}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        ) : (
                            <p style={{ color: "#858796" }}>Nenhum movimento registrado ainda.</p>
                        )}
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
